import { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import WebtoonCard from "@/components/feature/WebtoonCard";
import { getWebtoon, getWebtoonsByCategory, topRated } from "@/mocks/webtoons";
import { getCategory } from "@/mocks/categories";

export default function WebtoonDetail() {
  const { slug = "" } = useParams();
  const w = getWebtoon(slug);

  useEffect(() => {
    document.title = w ? `${w.title}·免费韩漫人气推荐 · 漫糖韩漫` : "作品详情 · 漫糖韩漫";
  }, [w]);

  const cat = getCategory(w?.category ?? "sweet");
  const related = getWebtoonsByCategory(w?.category ?? "sweet").filter((x) => x.slug !== slug).slice(0, 5);
  const top = topRated().slice(0, 5);

  if (!w) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center bg-background-50 px-4 text-center">
        <i className="ri-ghost-line text-6xl text-foreground-400"></i>
        <h1 className="mt-4 text-xl font-bold text-foreground-950">这部作品不存在或已下架</h1>
        <Link to="/" className="mt-6 rounded-full bg-primary-500 px-6 py-3 text-sm text-background-50">
          返回首页
        </Link>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />

      <section className="bg-foreground-950">
        <div className="mx-auto max-w-7xl px-4 pb-10 pt-24 md:px-6 md:pt-28">
          <nav aria-label="面包屑" className="flex items-center gap-1.5 text-xs text-background-400">
            <Link to="/" className="hover:text-background-100">首页</Link>
            <i className="ri-arrow-right-s-line"></i>
            <Link to="/category" className="hover:text-background-100">热门分类</Link>
            <i className="ri-arrow-right-s-line"></i>
            <Link to={`/category/${w.category}`} className="hover:text-background-100">{cat.name}</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-background-200">{w.title}</span>
          </nav>

          <div className="mt-6 grid grid-cols-1 gap-8 md:grid-cols-[280px_1fr]">
            <div className="mx-auto w-full max-w-[260px] md:mx-0">
              <div className="overflow-hidden rounded-3xl">
                <img
                  src={w.cover}
                  alt={`${w.title} 免费韩漫高清封面`}
                  title={`${w.title} 人气推荐作品`}
                  className="w-full object-cover object-top"
                />
              </div>
            </div>

            <div>
              <div className="flex flex-wrap items-center gap-2">
                <span className={`rounded-full px-3 py-1 text-xs font-medium text-background-50 ${cat.color}`}>{cat.name}</span>
                <span className="rounded-full bg-background-100 px-3 py-1 text-xs text-background-300">{w.status}</span>
                <span className="rounded-full bg-background-100 px-3 py-1 text-xs text-background-300">{w.updateDay}</span>
              </div>
              <h1 className="mt-3 font-heading text-3xl text-background-50 md:text-5xl">{w.title}</h1>
              <p className="mt-2 text-sm text-background-400">作者 · {w.author}</p>

              <div className="mt-5 flex flex-wrap items-center gap-4">
                <span className="flex items-center gap-2 rounded-2xl bg-accent-500/20 px-4 py-2.5">
                  <i className="ri-star-fill text-xl text-accent-400"></i>
                  <span className="text-2xl font-bold text-background-50">{w.rating.toFixed(1)}</span>
                </span>
                <div className="flex items-center gap-5 text-sm">
                  <span className="flex items-center gap-1.5 text-background-300"><i className="ri-eye-line"></i>{w.views}</span>
                  <span className="flex items-center gap-1.5 text-background-300"><i className="ri-heart-3-line"></i>{w.likes}</span>
                  <span className="flex items-center gap-1.5 text-background-300"><i className="ri-book-open-line"></i>{w.episode}话</span>
                </div>
              </div>

              <div className="mt-5 flex flex-wrap gap-2">
                {w.tags.map((t) => (
                  <span key={t} className="rounded-full border border-background-100/20 px-3 py-1 text-xs text-background-300">{t}</span>
                ))}
              </div>

              <p className="mt-6 max-w-3xl text-sm leading-relaxed text-background-300 md:text-base">{w.synopsis}</p>

              <div className="mt-7 flex flex-col gap-3 sm:flex-row">
                <button className="flex items-center justify-center gap-2 rounded-full bg-primary-500 px-8 py-3.5 text-sm font-medium text-background-50 whitespace-nowrap transition-colors hover:bg-primary-600">
                  <i className="ri-play-circle-fill text-lg"></i>
                  开始免费阅读
                </button>
                <button className="flex items-center justify-center gap-2 rounded-full border border-background-50/30 px-8 py-3.5 text-sm font-medium text-background-50 whitespace-nowrap transition-colors hover:bg-background-50/10">
                  <i className="ri-add-line"></i>
                  加入书架
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 剧情介绍 */}
      <section className="mx-auto max-w-7xl px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1fr_320px]">
          <div>
            <h2 className="flex items-center gap-2 text-xl font-bold text-foreground-950">
              <i className="ri-quill-pen-fill text-primary-600"></i>
              作品简介
            </h2>
            <p className="mt-4 text-sm leading-loose text-foreground-700 md:text-base">{w.synopsis}</p>
            <p className="mt-4 text-sm leading-loose text-foreground-600">
              该作品为免费韩漫热门推荐之一,凭借高评分与人气稳居免费韩漫排行榜前列,是编辑精选口碑佳作。
              无论你是初识韩漫的新读者,还是资深追更党,都能在这部作品里收获对味的阅读体验。
            </p>

            <h2 className="mt-10 flex items-center gap-2 text-xl font-bold text-foreground-950">
              <i className="ri-thumb-up-fill text-primary-600"></i>
              同类人气推荐
            </h2>
            <div className="mt-5 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5">
              {related.length > 0 ? (
                related.map((r) => <WebtoonCard key={r.id} item={r} />)
              ) : (
                <p className="col-span-full text-sm text-foreground-600">更多同类作品正在整理中</p>
              )}
            </div>
          </div>

          {/* sidebar */}
          <aside>
            <div className="rounded-3xl border border-background-200/70 bg-background-100 p-5">
              <h3 className="flex items-center gap-2 text-base font-bold text-foreground-950">
                <i className="ri-trophy-fill text-accent-600"></i>
                人气排行榜 TOP
              </h3>
              <div className="mt-4 space-y-2.5">
                {top.map((t, i) => (
                  <Link
                    key={t.id}
                    to={`/webtoon/${t.slug}`}
                    className={`flex items-center gap-3 rounded-xl p-2 transition-colors hover:bg-background-200/60 ${
                      t.slug === slug ? "bg-background-200" : ""
                    }`}
                  >
                    <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-lg text-sm font-bold ${
                      i === 0 ? "bg-accent-500 text-background-50" : i === 1 ? "bg-accent-300 text-foreground-900" : i === 2 ? "bg-accent-200 text-foreground-800" : "bg-background-200 text-foreground-600"
                    }`}>
                      {i + 1}
                    </span>
                    <span className="min-w-0 flex-1 truncate text-sm text-foreground-800">{t.title}</span>
                    <span className="text-xs text-foreground-500">{t.rating.toFixed(1)}</span>
                  </Link>
                ))}
              </div>
            </div>
          </aside>
        </div>
      </section>

      <Footer />
    </div>
  );
}